import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IVendorOrderInformationData } from '../../../types/vendorDashboard/IVendorOrderInformation';
import { TOrderPayload } from 'types/order/vendorDashboard/TOrderPayload';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { vendorOrderInitialState } from './interfaces';

export const vendorOrderReducer = createSlice({
  name: 'vendorOrderInformation',
  initialState: vendorOrderInitialState,
  reducers: {
    setVendorOrderDataAction: (state, action: PayloadAction<TOrderPayload<IVendorOrderInformationData>>) => {
      state.order[action.payload.orderId] = action.payload.value;
    },
    setVendorOrderFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.orderFetchStatus = action.payload;
    },
    setVendorOrderErrorAction: (state, action: PayloadAction<string | undefined>) => {
      state.orderError = action.payload;
    },
    setSendToSpruceFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.sentToSpruceFetchStatus = action.payload;
    },
    setSendToSpruceErrorAction: (state, action: PayloadAction<string | undefined>) => {
      state.sentToSpruceError = action.payload;
    },
    reset: () => vendorOrderInitialState,
  },
});
export const {
  setVendorOrderDataAction,
  setVendorOrderFetchStatusAction,
  setVendorOrderErrorAction,
  setSendToSpruceErrorAction,
  setSendToSpruceFetchStatusAction,
  reset,
} = vendorOrderReducer.actions;
